import { useEffect, useState } from "react";
import { CustomerAPI } from "@/apis/sales";
import { Select } from "@arco-design/web-react";
import _ from "lodash";

const CustomerSelect = (props) => {
    const { type, ...restProps } = props;
    const [options, setOptions] = useState([]);

    useEffect(() => {
        const getOptions = async () => {
            const values = await CustomerAPI.actives();
            const opts = _.map(_.orderBy(values, ['customerName'], ['asc']), (item) => ({
                value: item.id,
                label: item.customerName
            }));
            setOptions(opts);
        }

        getOptions();
    }, [type]);

    return (
        <Select {...restProps}
            showSearch
            filterOption={(inputValue, option) =>
                _.toLower(option.props.value).indexOf(inputValue.toLowerCase()) >= 0 ||
                option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
            }
            options={options}
            onChange={(val) => props.onChange && props.onChange(val)}>
        </Select>
    );
}

export default CustomerSelect;
